import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const VerifyEmail = () => import('@/views/pages/VerifyEmail')

const UserList = () => import('@/views/pages/UserList')
const UserDetail = () => import('@/views/pages/UserDetail')
const DeviceList = () => import('@/views/pages/DeviceList')
const DeviceDetail = () => import('@/views/pages/DeviceDetail')
const GroupList = () => import('@/views/pages/GroupList')
const GroupDetail = () => import('@/views/pages/GroupDetail')
const LogList = () => import('@/views/pages/LogList')
const LogDetail = () => import('@/views/pages/LogDetail')
const Settings = () => import('@/views/pages/Settings')
const AddGroupWithUsers =() => import('@/views/pages/AddGroupWithUsers')
const AdminList = () => import('@/views/pages/AdminList')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: UserList,
            },
            {
              path: ':id',
              meta: { label: 'User Detail'},
              name: 'User',
              component: UserDetail,
            },
          ]
        },
        {
          path: 'admins',
          name: 'admins',
          component: AdminList
        },        
        {
          path: 'groups',
          meta: { label: 'Groups'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: GroupList,
            },
            {
              path: 'addGroupWithUsers',
              meta: { label: 'Add Group With Users'},
              name: 'AddGroupWithUsers',
              component: AddGroupWithUsers,
            },
            {
              path: ':id',
              meta: { label: 'Group Detail'},
              name: 'Group',
              component: GroupDetail,
            },
          ]
        },        
        {
          path: 'devices',
          meta: { label: 'Devices'},
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '',
              component: DeviceList,
            },
            {
              path: ':id',
              meta: { label: 'Device Detail'},
              name: 'Device',
              component: DeviceDetail,
            }
          ]
        },
        {
          path: 'logs',
          meta: { label: 'Logs'},
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '',
              component: LogList,
            },
            {
              path: ':id',
              meta: { label: 'Log Detail'},
              name: 'Log',
              component: LogDetail,
            }            
          ]
        },
        {
          path: 'settings',
          meta: { label: 'Settings'},
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '',
              component: Settings,
            },
          ]
        },                
     ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'resetpassword',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: 'verifyEmail',
          name: 'VerifyEmail',
          component: VerifyEmail
        }        
      ]
    },
    {
      path: '*',
      redirect: '/pages/404'
    }
  ]
})
